import { useMerchantContext } from "lib/contexts/MerchantProvider";
import { ItemCardAlignType } from "lib/types/merchantConfigTypes";

/**
 * Line item layout, backend driven via `ui_attributes.item_card.align`. Cart and checkout carry
 * their own copy of the attribute, so the calling surface decides which one is read.
 *
 * Anything other than an explicit "row" keeps the legacy stacked layout.
 */
export const useItemCardAlign = (isCartItem: boolean): ItemCardAlignType => {
  const {
    state: { cartMetadata, checkoutMetadata },
  } = useMerchantContext();

  const align = isCartItem
    ? cartMetadata?.uiAttributes?.itemCardConfig?.align
    : checkoutMetadata?.uiAttributes?.itemCardConfig?.align;

  return align === "row" ? "row" : "column";
};
